import { tokens } from '@fluentui/react-components';
import React from 'react';
export var applyTextHighlights = function (text) {
    if (!text) {
        return React.createElement(React.Fragment, null);
    }
    var openMarker = '&lt;c0&gt;';
    var closeMarker = '&lt;/c0&gt;';
    var textStartsWithHighlight = text.search(openMarker) === 0;
    var arr = text.split(openMarker).join(closeMarker).split(closeMarker);
    // trim blanks
    var filteredArr = arr.filter(function (str) { return str !== ''; });
    return (React.createElement(React.Fragment, null, filteredArr.map(function (strChunk, idx) {
        var strChunkIsHighlight = idx % 2 === (textStartsWithHighlight ? 0 : 1);
        return strChunkIsHighlight ? (React.createElement("span", { key: idx, style: { color: tokens.colorBrandForeground1 } }, strChunk)) : (React.createElement("span", { key: idx }, strChunk));
    })));
};
//# sourceMappingURL=applyTextHighlights.js.map